/**
 * Created by Andrey Popov on 1/24/23.
 */

const BombOnCard = function (card, options) {
    this.card = card;
    this.counter = options.counter || 5;
    this.card.featureTrigger = Card.MOVES.PLAY | Card.MOVES.SHIFT;

    this.onChangeCounter = function () {};
    this.onRemove = function () {};
    this.onFlip = function () {};
    this.onHide = function () {};

    Game.currentGame.counter.registerStage(32, BombOnCard.process);
};

BombOnCard.prototype.getViewClass = function () {
    return BombOnCardView;
};

BombOnCard.prototype.isActive = function () {
    return this.card.isOpen();
};

BombOnCard.prototype.collect = function () {
    return this.remove();
};

BombOnCard.prototype.isBlocked = function () {
    return false;
};

BombOnCard.prototype.remove = function () {
    this.card.removeComponent(BombOnCard);
    this.onRemove();
};

BombOnCard.prototype.toJSON = function () {
    return {
        name: "bomb",
        counter: this.counter
    };
};

BombOnCard.prototype.handleFlip = function () {
    this.onFlip();
};

BombOnCard.prototype.handleClick = function () {
};

BombOnCard.prototype.danceMove = function () {
    this.counter--;

    this.onChangeCounter();

    if (this.counter <= 0) {
        this.counter = 0;
        this.readyToExplode = true;
    }
};

BombOnCard.prototype.addUntilExplode = function (amount) {
    this.counter += amount;
    this.onChangeCounter();
};

BombOnCard.prototype.getDangerLevel = function () {
    for (let i = 0; i < BombOnCard.DANGER_THRESHOLDS.length; i++) {
        if (this.counter >= BombOnCard.DANGER_THRESHOLDS[i]) {
            return i;
        }
    }
};

BombOnCard.process = function () {
    const game = Game.currentGame;
    const bombs = game.table.cards.map((card) => card.findComponent(BombOnCard)).filter((bomb) => bomb && bomb.isActive() && !bomb.card.isNearToDestroy());
    const toExplode = bombs.filter((bomb) => bomb.readyToExplode);

    if (toExplode.length === 0) {
        return;
    }

    toExplode.forEach((bomb) => {
        bomb.readyToExplode = false;
    });

    game.hideHint();

    let success = false;

    cleverapps.focusManager.display({
        focus: "PostponeBombWindow",
        control: "panel_info",

        actions: [
            function (f) {
                cleverapps.timeouts.setTimeout(f, 1000);
            },
            function (f) {
                new ProlongationWindow(game.prolongation, {
                    reward: Prolongation.REWARDS.BOMB,
                    onSuccess: function () {
                        success = true;
                        f();
                    },
                    onGiveUp: f
                });
            },
            function (f) {
                if (success) {
                    bombs.forEach((bomb) => {
                        bomb.addUntilExplode(BombOnCard.MOVES_TO_ADD);
                    });
                    if (game.open && game.open.extraSlot && game.open.extraSlot.isOfferAvailable()) {
                        game.open.extraSlot.trigger("removeExtraSlotButton", game.open.extraSlot);
                    }
                } else {
                    toExplode.forEach((bomb) => {
                        bomb.remove();
                    });
                    BombOnCardView.explosion();
                }
                cleverapps.timeouts.setTimeout(() => {
                    if (!success) {
                        game.lose();
                    }
                    f();
                }, 1200);
            }
        ]
    });
};

BombOnCard.MOVES_TO_ADD = 5;
BombOnCard.DANGER_THRESHOLDS = [7, 4, 0];